import { ITavusPersonaFormik } from 'entities/tavus/persona';
import { FormikProps } from 'formik';
import { FC, useState } from 'react';
import { cn } from 'shared/lib';
import { GREETING_PLACEHOLDER, KNOWLEDGE_PLACEHOLDER } from '../lib';
import { ChooseModelAiModal } from 'features/choose-model-ai';
import { aiModels } from 'entities/tavus/ai-model';
import { VscChevronDown } from 'react-icons/vsc';

import { featureFlags } from 'shared/model';
import FormError from 'components/Forms/FormError/FormError';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}

export const General: FC<IProps> = ({ formik }) => {
  const [openChoseAiModelModal, setOpenChoseAiModelModal] = useState(false);
  return (
    <div className="ag-flex ag-flex-col ag-gap-y-6 ag-h-full">
      <div className="ag-flex ag-flex-col ag-relative ag-text-neutral-900 ag-font-medium ag-text-sm">
        <div className={'ag-font-semibold ag-mb-4'}>Model</div>
        <div className="ag-text-gray-muted">
          Select the AI model that powers your agent&#39;s responses and
          interactions
        </div>
        <div className="ag-relative">
          <input
            className={cn(
              'ag-border ag-w-full ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0',
              formik.errors.name && formik.touched.name
                ? 'ag-text-red-900  focus:ag-border-red-500'
                : 'placeholder:ag-text-gray-400 focus:ag-border-primary-800'
            )}
            placeholder="My Video Agent"
            onClick={() => setOpenChoseAiModelModal(true)}
            value={
              aiModels.find((model) => model.value === formik.values.model)
                ?.name
            }
            name="model"
            id="name"
            readOnly
          />
          <VscChevronDown
            className={`ag-right-2 ag-transform ag-top-1/2 -ag-translate-y-1/2 ag-absolute ${
              openChoseAiModelModal && 'ag-rotate-180'
            } `}
          />
        </div>
      </div>
      <div className="ag-flex ag-flex-col ag-relative">
        <label
          className="ag-mb-1.5 ag-text-neutral-900 ag-text-sm ag-font-semibold"
          htmlFor="name"
        >
          <div>Knowledge</div>
          <div className="ag-text-sm ag-font-normal ag-text-gray-muted">
            Enter information the Video Agent needs to know.
          </div>
        </label>

        <textarea
          className={cn(
            'ag-border ag-text-neutral-900 ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-text-sm ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0',
            formik.errors.context && formik.touched.context
              ? 'ag-text-red-900  focus:ag-border-red-500'
              : 'placeholder:ag-text-neutral-500 focus:ag-border-primary-800'
          )}
          placeholder={KNOWLEDGE_PLACEHOLDER}
          name="context"
          id="context"
          rows={3}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          value={formik.values.context}
        />
        {formik.errors.context && formik.touched.context && (
          <FormError>{formik.errors.context}</FormError>
        )}
      </div>
      <div className="ag-flex ag-flex-col ag-relative">
        <label
          className="ag-mb-1.5 ag-text-neutral-900 ag-text-sm ag-font-semibold"
          htmlFor="greeting"
        >
          <div>Greeting (Optional)</div>
          <div className="ag-text-sm ag-font-normal ag-text-gray-muted">
            This is the first thing they’ll say when starting a new
            conversation.
          </div>
        </label>

        <textarea
          className={cn(
            'ag-border ag-text-neutral-900 ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-text-sm ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0',
            formik.errors.customGreeting && formik.touched.customGreeting
              ? 'ag-text-red-900  focus:ag-border-red-500'
              : 'placeholder:ag-text-neutral-500 focus:ag-border-primary-800'
          )}
          placeholder={GREETING_PLACEHOLDER}
          name="customGreeting"
          id="customGreeting"
          rows={3}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          value={formik.values.customGreeting}
        />
        {formik.errors.customGreeting && formik.touched.customGreeting && (
          <FormError>{formik.errors.customGreeting}</FormError>
        )}
      </div>
      <ChooseModelAiModal
        models={aiModels.map((item) => ({
          value: item.value,
          name: item.name,
          description: item.description,
          icon: item.iconBlack
        }))}
        onChoose={(value) => formik.setFieldValue('model', value)}
        setOpen={setOpenChoseAiModelModal}
        isOpen={openChoseAiModelModal}
      />
    </div>
  );
};
